import {
    ANNOUNCEMENTS_FIELD_CHANGED,
    FETCH_ANNOUNCEMENTS,
    FETCH_ANNOUNCEMENTS_FAILED,
    FETCH_ANNOUNCEMENTS_SUCCESSFUL,
    FETCH_MORE_ANNOUNCEMENTS,
    FETCH_MORE_ANNOUNCEMENTS_FAILED,
    FETCH_MORE_ANNOUNCEMENTS_SUCCESSFUL,
    FETCH_MORE_SCHEDULED_ANNOUNCEMENTS, FETCH_MORE_SCHEDULED_ANNOUNCEMENTS_FAILED,
    FETCH_MORE_SCHEDULED_ANNOUNCEMENTS_SUCCESSFUL,
    FETCH_SCHEDULED_ANNOUNCEMENTS,
    FETCH_SCHEDULED_ANNOUNCEMENTS_FAILED,
    FETCH_SCHEDULED_ANNOUNCEMENTS_SUCCESSFUL,
    HIDE_NEW_ANNOUNCEMENT_MODAL,
    PUSH_ANNOUNCEMENT, PUSH_SCHEDULED_ANNOUNCEMENT,
    SEND_ANNOUNCEMENT,
    SEND_ANNOUNCEMENT_FAILED,
    SEND_ANNOUNCEMENT_SUCCESSFUL,
    SHOW_NEW_ANNOUNCEMENT_MODAL

} from "../actions/Types";

const INITIAL_STATE = {
    startAt: 20,
    announcements: [],
    announcementsLoading: false,
    announcementsRefreshing: false,
    moreAnnouncementsLoading: false,

    scheduledAnnouncementsLoading: false,
    scheduledAnnouncementsRefreshing: false,
    scheduledAnnouncements: [],

    moreScheduledAnnouncementsLoading: false,

    announcement: {},
    scheduledAnnouncement: {},

    showNewAnnouncementModal: false,

    announcementTitle: "",
    announcementDescription: "",
    isPDF: false,
    pdf: [],
    deadline: false,
    isScheduled: false,
    announcementDate: "",
    tags: [],
    generalNotification: true,
    groupNotification: [],

    sendAnnouncementLoading: false
};

const announcementsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case ANNOUNCEMENTS_FIELD_CHANGED:
            return { ...state, [action.payload.prop]: action.payload.value };

        //fetch announcements
        case FETCH_ANNOUNCEMENTS:
            return { ...state, announcementsLoading: true, announcementsRefreshing: true };
        case FETCH_ANNOUNCEMENTS_SUCCESSFUL:
            return { ...state, announcementsLoading: false, announcementsRefreshing: false, announcements: action.payload.announcements, startAt: action.payload.startAt };
        case FETCH_ANNOUNCEMENTS_FAILED:
            return { ...state, announcementsLoading: false, announcementsRefreshing: false };

        //more announcements
        case FETCH_MORE_ANNOUNCEMENTS:
            return { ...state, moreAnnouncementsLoading: true };
        case FETCH_MORE_ANNOUNCEMENTS_SUCCESSFUL:
            return { ...state, announcements: action.payload.announcements, startAt: action.payload.startAt, moreAnnouncementsLoading: false };
        case FETCH_MORE_ANNOUNCEMENTS_FAILED:
            return { ...state, moreAnnouncementsLoading: false };

        //fetch scheduled announcements
        case FETCH_SCHEDULED_ANNOUNCEMENTS:
            return { ...state, scheduledAnnouncementsLoading: true, scheduledAnnouncementsRefreshing: true };
        case FETCH_SCHEDULED_ANNOUNCEMENTS_SUCCESSFUL:
            return { ...state, scheduledAnnouncementsLoading: false, scheduledAnnouncementsRefreshing: false, scheduledAnnouncements: action.payload.announcements, startAt: action.payload.startAt };
        case FETCH_SCHEDULED_ANNOUNCEMENTS_FAILED:
            return { ...state, scheduledAnnouncementsLoading: false, scheduledAnnouncementsRefreshing: false };

        //more scheduled announcements
        case FETCH_MORE_SCHEDULED_ANNOUNCEMENTS:
            return { ...state, moreScheduledAnnouncementsLoading: true };
        case FETCH_MORE_SCHEDULED_ANNOUNCEMENTS_SUCCESSFUL:
            return { ...state, scheduledAnnouncements: action.payload.announcements, startAt: action.payload.startAt, moreScheduledAnnouncementsLoading: false };
        case FETCH_MORE_SCHEDULED_ANNOUNCEMENTS_FAILED:
            return { ...state, moreScheduledAnnouncementsLoading: false };

            //new announcements
        case SHOW_NEW_ANNOUNCEMENT_MODAL:
            return { ...state, showNewAnnouncementModal: true };
        case HIDE_NEW_ANNOUNCEMENT_MODAL:
            return { ...state, showNewAnnouncementModal: false };

        case SEND_ANNOUNCEMENT:
            return { ...state, sendAnnouncementLoading: true };
        case SEND_ANNOUNCEMENT_SUCCESSFUL:
            return { ...state, sendAnnouncementLoading: false, showNewAnnouncementModal: false, announcementTitle: "", announcementDescription: "", pdf: "", announcementDate: "", tags: [], deadline: false };
        case SEND_ANNOUNCEMENT_FAILED:
            return { ...state, sendAnnouncementLoading: false };

        case PUSH_ANNOUNCEMENT:
            return { ...state, announcement: action.payload };

        case PUSH_SCHEDULED_ANNOUNCEMENT:
            return { ...state, scheduledAnnouncement: action.payload }

        default:
            return state;
    }
};

export default announcementsReducer;